import { BlogPostStatus } from '@/models/blogPost.model';

const blogPostStatusOptions = [
  { value: BlogPostStatus.DRAFT, label: String(BlogPostStatus.DRAFT) },
  { value: BlogPostStatus.SCHEDULED, label: String(BlogPostStatus.SCHEDULED) },
  { value: BlogPostStatus.PUBLISHED, label: String(BlogPostStatus.PUBLISHED) },
];

export default blogPostStatusOptions;
